import React, { FunctionComponent } from 'react';
import './divider.scss';

type DividerProps = {
  fullWidth?: boolean,
  style?: React.CSSProperties,
  className?: string,
}

const Divider: FunctionComponent<DividerProps> = ({ fullWidth = true, className = '', style }) => (
  <div className={`divider ${className} ${fullWidth ? 'w-12' : ''}`} style={style || {}} />
);

export default Divider;
